/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

/**
 * Organization Themes Module
 *
 * Centralized exports for multi-tenant theming system.
 * Provides theme definitions, utilities, and type definitions.
 *
 * @module themes
 */

export * from "./organization-themes";
